module.exports = __webpack_public_path__ + "static/logos/logo-roadsurfer-573a48484dfa14914ea7bdaa13784982.svg";